module.exports = __webpack_public_path__ + "app/principal/modals/modal-notification-kc_YiyU8.html";